import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=586548c6&scoped=true"
import script from "./SubmitSuccess.vue?vue&type=script&lang=ts"
export * from "./SubmitSuccess.vue?vue&type=script&lang=ts"
import style0 from "./SubmitSuccess.vue?vue&type=style&index=0&id=586548c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586548c6",
  null
  
)

export default component.exports